module.exports = __webpack_public_path__ + "29fad869c61a133c2bc3153a11add4a4.svg";